var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m6.365 1.829.032.021 9.371 6.248c.272.18.523.348.716.504.202.162.44.388.576.717.18.436.18.926 0 1.362-.137.33-.374.555-.576.717-.193.156-.444.324-.716.504l-9.403 6.27c-.331.22-.63.419-.882.556-.253.137-.6.294-1.006.27a1.78 1.78 0 0 1-1.311-.702c-.245-.324-.308-.7-.334-.987a12 12 0 0 1-.026-1.043V3.734c0-.399 0-.757.026-1.043.026-.287.089-.663.334-.987.313-.414.792-.67 1.31-.702.406-.024.754.133 1.007.27s.55.336.882.557",
    clipRule: "evenodd"
  })));
};
export default SvgPlay;